import config from '../config/config';
import apiService from './apiService';
import {getExtCustomerId} from './extCustomerId';

const authService = {
    checkLoggedIn: (cb) => {
        fetch(`${config.apiEndpoint}auth/check`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Accept-Language': localStorage.getItem('lang') || 'ka',
                'extCustomerId': getExtCustomerId(),
            },
            credentials: 'include',
        })
            .then((res) => {
                if (config.ENV === 'PRODUCTION') {
                    console.clear();
                }
                let loggedIn;
                if (res.status === 401) {
                    localStorage.removeItem('loggedIn');
                    loggedIn = false;
                } else {
                    localStorage.setItem('loggedIn', true);
                    loggedIn = true;
                }
                cb(loggedIn);
            })
            .catch(() => {
                if (config.ENV === 'PRODUCTION') {
                    console.clear();
                }
                localStorage.removeItem('loggedIn');
                cb(false);
            });
    },
    getClientInfo: (cb) => {
        authService.checkLoggedIn((loggedIn) => {
            if (loggedIn) {
                apiService.execute({
                    url: 'auth/info',
                })
                .then((res) => {
                    const client = res.json.client;
                    const phones = res.json.clientPhones;
                    const mails = res.json.clientMails;
                    const activePackageName = res.json.activePackageName;
                    client.mails = mails;
                    client.activePackageName = activePackageName;
                    for (let i = 0; i < phones.length; i++) {
                        if (phones[i].defaultContact === 'Y' && phones[i].contact.startsWith('995')) {
                            client.isFinancialNumber = true;
                            client.phone = phones[i].contact.slice(-9);
                            break;
                        } else {
                            client.isFinancialNumber = false;
                        }
                    };
                    if (mails.length > 0) {
                        client.mail = mails[0].mail;
                        for (let i = 0; i < mails.length; i++) {
                        if (mails[i].defaultContact === 'Y') {
                            client.mail = mails[i].mail;
                            break;
                            }
                        }
                    } else client.mail = '';
                    const {categoryType, firstName, lastName, sex, clientKey} = client;
                    localStorage.setItem('userInfo',
                        JSON.stringify({categoryType, firstName, lastName, sex, clientKey})
                    );
                    cb(client);
                })
                .catch((err) => {
                    console.log(err);
                    if (cb) cb(null);
                });
            } else {
                cb(null);
            }
        });
    },
};

authService.loginWithPopupWindow = (lang) => {
    return new Promise((resolve) => {
        const w = Math.min(window.screen.width, 500);
        const h = Math.min(window.screen.height, 500);
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        // eslint-disable-next-line max-len
        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        // eslint-disable-next-line max-len
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const systemZoom = width / window.screen.availWidth;
        const systemZoomH = height / window.screen.availHeight;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoomH + dualScreenTop;
        const _newWindow = window.open(`${config.authIframeUrl}?lang=${lang}&popup=1`, 'ssowindow', `
            menutbar=1,
            resizable=0, 
            location=0,
            menubar=0,
            status=0,
            width=${w / systemZoom}, 
            height=${h / systemZoomH}, 
            top=${top}, 
            left=${left}
    `
        );
        const callback = (e) => {
            if (!config.ssoTrustedOrigins.includes(e.origin)) {
                return;
            }
            try {
                const data = typeof e.data === 'object' ? e.data : JSON.parse(e.data);
                // if (!data || !data.fromBog) {
                //   return;
                // }
                if (data.login) {
                    localStorage.setItem('loggedIn', true);
                    window.dispatchEvent(new CustomEvent('logged-in', {bubbles: true, composed: true}));
                    _newWindow.close();
                    resolve();
                }
                window.removeEventListener('message', callback);
            } catch (err) {
                console.log(err);
            }
        };

        const interval = setInterval(() => {
            if (localStorage.getItem('loginState')) {
                localStorage.setItem('loggedIn', true);
                window.dispatchEvent(new CustomEvent('logged-in', {bubbles: true, composed: true}));
                _newWindow.close();
                clearInterval(interval);
                window.removeEventListener('message', callback);
                localStorage.removeItem('loginState');
                resolve();
            }
        }, 1000);

        setTimeout(() => {
            _newWindow.close();
            window.removeEventListener('message', callback);
            clearInterval(interval);
        }, 1000 * 50);

        window.addEventListener('message', callback);
    });
};

export default authService;
